import '../../../css/buttons.css';
const AddButton = ({ btnText, btnFunction, btnWidth, customClass, disableBtn }) => {
  const getAddButtonClass = () => {
    let btnClass = 'pointer d-flex justify-content-center align-items-center';
    if (customClass) {
      btnClass += ` ${customClass}`;
    } else {
      btnClass += ' addBtn';
    }
    if (disableBtn) {
      btnClass += ' menu__add-btn--disabled';
    }
    return btnClass;
  };
  const addButtonClass = getAddButtonClass();
  return (
    <>
      <div
        className={addButtonClass}
        onClick={() => btnFunction()}
        style={{ width: `${btnWidth}%` }}>
        <div className='fw-500 fs-16'>{btnText}</div>
      </div>
    </>
  );
};

export default AddButton;
